import axios from 'axios';
import { getContext } from '@fiverr-private/fiverr_context';
import pathfinder from '@fiverr-private/pathfinder';
import { logger } from '@fiverr-private/obs';
import { MembersListReponse } from '../types';

export interface GetMembersListOptions {
    includeSelf: boolean;
}

export const getMembersList = async (options?: GetMembersListOptions) => {
    const { userId } = getContext();
    const url = pathfinder('business_team_members_api');

    try {
        const { data } = await axios.get<MembersListReponse>(url);
        return data.membersList.filter(
            (member) => member.status === 'active' && (options?.includeSelf || Number(member.userId) !== Number(userId))
        );
    } catch (e) {
        logger.error(e as Error, { description: 'Failed to get members list' });
        throw e;
    }
};
